import type { Enums } from "../types";

/**
 * Every state an order or one of its picking rounds can hold, in lifecycle order rather than the
 * order the enum declares them — which is what a filter list reads top to bottom.
 *
 * Neither level uses all six. A round moves `pending` -> `open` -> `picking` -> `complete` and is
 * never `in-progress`; an order is never `picking`, and holds `in-progress` exactly while its
 * rounds disagree with each other. The list is shared anyway, because both columns are the same
 * `orderState` and a filter over the order list has to offer what that column can contain.
 *
 * `satisfies` rather than a plain annotation, so the tuple keeps its literal members for
 * `z.enum` while still failing to compile if the database enum gains a state this list does not.
 */
export const ORDER_STATES = [
	"pending",
	"open",
	"picking",
	"in-progress",
	"complete",
	"canceled",
] as const satisfies ReadonlyArray<Enums<"orderState">>;
